import { useEffect, useMemo, useRef } from "react";
import s from "./classes-board.module.scss";
import classNames from "classnames";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import { addDays, endOfWeek } from "date-fns";
import { DayCard } from "@features/schedule/ui/day-card/day-card";
import { Button } from "@shared/ui/button/button";
import months from '@shared/model/months.json'

const getMonthAndDate = (d) => {
  const month = d.getMonth();
  const date = d.getDate();

  return [
    months.find((el) => el.number === month).genitive.toLowerCase(),
    date,
  ];
};

export const ClosedClassesBoard = ({
  start_date,
  end_date,
  set_end_date,
  set_start_date,
  className,
}) => {
  const todayRef = useRef(null);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const goToPreviousWeek = () => {
    const previousWeekStart = addDays(start_date, -7);
    const previousWeekEnd = endOfWeek(previousWeekStart);

    set_start_date(previousWeekStart);
    set_end_date(previousWeekEnd);
  };

  // Функция для перехода к следующей неделе
  const goToNextWeek = () => {
    const nextWeekStart = addDays(start_date, 7);
    const nextWeekEnd = endOfWeek(nextWeekStart);

    set_start_date(nextWeekStart);
    set_end_date(nextWeekEnd);
  };

  const fullDays = useMemo(() => {
    let startDate = new Date(start_date);
    startDate.setHours(0, 0, 0, 0);
    const endDate = new Date(end_date);
    endDate.setHours(0, 0, 0, 0);

    let days = {};
    while (startDate <= endDate) {
      let dayName = startDate
        .toLocaleString("ru-RU", { weekday: "long" })
        .toLowerCase();
      days[dayName] = new Date(startDate); // Сохраняем объект даты для каждого дня
      startDate.setDate(startDate.getDate() + 1);
    }
    return days;
  }, [start_date, end_date]);

  useEffect(() => {
    if (todayRef?.current) {
      todayRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    }
  }, [todayRef]);

  return (
    <div className={classNames(s.weekCard, className)}>
			<div className={s.overlay}>
				Необходимо подтвердить почту, чтобы пользоваться всем функционалом
			</div>
          <div className={s.weekHeader}>
            {start_date && end_date && (
              <div className={s.selectWrapper}>
                <Button
                  onClick={() => goToPreviousWeek()}
                  label={<IconChevronLeft size={10} />}
                  theme="secondary"
                  className={s.monthBtn}
                />
                <span>
                  {`${getMonthAndDate(start_date)[1]} ${
                    getMonthAndDate(start_date)[0]
                  } - ${getMonthAndDate(end_date)[1]} ${
                    getMonthAndDate(end_date)[0]
                  }`}
                </span>
                <Button
                  onClick={() => goToNextWeek()}
                  label={<IconChevronRight size={10} />}
                  theme="secondary"
                  className={s.monthBtn}
                />
              </div>
            )}
          </div>
          <div className={s.hLine}></div>
					<div className={s.weekWrapper}>
						{Object?.entries(fullDays)?.map(([dayName, date]) => {
								return (
									<DayCard
										key={date + dayName}
										{...{
											date,
											dayName,
											todayRef,
										}}
										groupedTimeSlots={{}}
									/>
								);
							})}
					</div>
    </div>
  );
};
